import { render, staticRenderFns } from "./Subheading.vue?vue&type=template&id=346fbd97&scoped=true"
var script = {}
import style0 from "./Subheading.vue?vue&type=style&index=0&id=346fbd97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346fbd97",
  null
  
)

export default component.exports